import { Component, OnInit } from '@angular/core';
import { NotificationsService } from './notifications.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    notificationList: any = [];
    templateId:any;
    constructor(
        private _notificationsService: NotificationsService,
        private _router :Router
    ) { }
    ngOnInit() {
        this._notificationsService.getAllByTeamId()
            .subscribe((data: any) => {
                console.log('TCL: NotificationsComponent -> ngOnInit -> data', data);
                this.notificationList = data.data[0].schedules.concat(data.data[0].notifications);
            }, (err) => {
                console.log('TCL: NotificationsComponent -> ngOnInit -> err', err);
            });
    }

    navigateSafteyShare(notifications){
        if(notifications.id && notifications.notes){
        this._router.navigateByUrl('/notificationDetails?notesId=' + notifications.id)    
        }else{
            if(Object.keys(notifications.data.data).length > 1){
            this._router.navigateByUrl('/notificationDetails?&taskId=' + notifications.id);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.component.ts